import { apiClient, ApiClient } from "@/lib/api/api-client";
import {
  RegisterData,
  LoginCredentials,
  AuthResponse,
} from "@/modules/types/auth";

export class AuthService {
  private BASE_PATH =
    process.env.API_AUTH_ENDPOINT || "http://localhost:8081/auth";
  private apiClient: ApiClient = apiClient;
  private apiVersion = "v1.0.0";
  constructor(apiVersion?: string) {
    this.apiVersion = apiVersion || this.apiVersion;
  }

  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    return this.apiClient.fetch<AuthResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/login`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(credentials),
      },
    );
  }

  async register(data: RegisterData): Promise<AuthResponse> {
    return this.apiClient.fetch<AuthResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/candidate/signup`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(data),
      },
    );
  }

  async registerEmployer(data: RegisterData): Promise<AuthResponse> {
    return this.apiClient.fetch<AuthResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/business/signup`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(data),
      },
    );
  }

  async logout(): Promise<void> {
    return this.apiClient.fetch<void>(
      `${this.BASE_PATH}/${this.apiVersion}/logout`,
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
      },
    );
  }
}

export const authService = new AuthService();
